import API from './ApiServer.js'

//OA模块的,模块写完了 实验接口后续会专门到一个oa模块接口文件里面
export const getWorkflowTemplateListInfoList = params => API.post('oa/workflowTemplate/listSelect', params)



// WEBPACK FOOTER //
// ./src/factory-api/index.js